"use strict";
function pagination(){
    document.querySelectorAll(".load-more").forEach((btn) => {
      btn.classList.remove('loading');
      var url = btn.getAttribute('href');
      if (btn.classList.contains("infinite")){
        var observer = new IntersectionObserver(
          function(entries){
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1){
                loadMoreproducts(url);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(btn);
      } else {
        btn.addEventListener("click",(e) => {
            e.preventDefault();
            btn.classList.add('loading');
            loadMoreproducts(url);
          },
          false
        );
      }
    });
}
pagination();
function loadMoreproducts(url){
    fetch(url).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'),
        products = document.getElementById('collection-products'),
        productsSource = html.querySelector('#collection-products').innerHTML,
        pagination = document.getElementById('pagination'),
        paginationSource = html.querySelector('#pagination');

      if(products) products.insertAdjacentHTML('beforeend', productsSource);
      if(pagination && paginationSource) {
        pagination.innerHTML = paginationSource.innerHTML;
      } else {
        pagination.innerHTML = '';
      }
    })
    .finally(() => {
      pagination();
      if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
      initializeVideos();initBgimages();
      initializeScrollAnimationTrigger();
    })
    .catch((e) => {
      console.error(e);
    });
}

let collectionFilterRequest;

async function renderCollectionPage(url, updateHistory = true) {
  const collection = document.getElementById('Collection');
  if (!collection) return;

  if (collectionFilterRequest) collectionFilterRequest.abort();
  collectionFilterRequest = new AbortController();
  collection.setAttribute('aria-busy', 'true');
  collection.classList.add('filter-loading');

  try {
    const response = await fetch(url, {
      signal: collectionFilterRequest.signal,
      headers: {'X-Requested-With': 'XMLHttpRequest'}
    });
    if (!response.ok) throw new Error(`Filter request failed: ${response.status}`);

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const updatedCollection = html.getElementById('Collection');
    if (!updatedCollection) throw new Error('Updated collection markup was not found');

    collection.replaceWith(updatedCollection);
    if (updateHistory) window.history.pushState({}, '', url);

    pagination();
    if (theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
    if (typeof initializeVideos === 'function') initializeVideos();
    if (typeof initBgimages === 'function') initBgimages();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
  } catch (error) {
    if (error.name !== 'AbortError') window.location.assign(url);
  }
}

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      var topFilters = document.querySelector(".filter-horizontal");

      this.mql = window.matchMedia('(min-width: 768px)');
  
      if(topFilters && this.mql.matches === true) this.blockToggle();
      this.accordionFilters();
      this.priceRangeSlider();
      this.selectSort();
      const form = this.querySelector('#CollectionFiltersForm');
      if (form) form.addEventListener('submit', this.submitFilters.bind(this));
      this.addEventListener('change', this.autoApplyDesktop.bind(this));

  }
  submitFilters(event){
    event.preventDefault();
    const form = event.currentTarget;
    const params = new URLSearchParams(new FormData(form));
    Array.from(params.entries()).forEach(([key, value]) => {
      if(value === '') params.delete(key);
    });
    const url = `${form.action}${params.toString() ? `?${params}` : ''}`;
    document.documentElement.classList.remove('activ-filter', 'show-overly');
    renderCollectionPage(url);
  }
  autoApplyDesktop(event){
    if (!this.mql.matches || event.target.matches('#sort-by')) return;
    if (event.target.matches('input[type="checkbox"], input[type="radio"]')) {
      event.target.form?.requestSubmit();
    }
  }
  selectSort(){
    var shortby = document.getElementById('sort-by');
    if(!shortby) return;
    shortby.addEventListener('change', function(){
      var form = document.getElementById('CollectionFiltersForm');
      if(form) form.requestSubmit();
    });
  }
  priceRangeSlider(){
    const isPriceRange = document.getElementById('priceSlider');
    if(!isPriceRange) return;
    const priceSlider = document.getElementById('priceSlider'),
      min = document.getElementById('Filter-Price-GTE'),
      max = document.getElementById('Filter-Price-LTE');

    priceSlider.addEventListener('change', (evt) => {
        min.value = evt.detail.value1.toString();
        max.value = evt.detail.value2.toString();
    });
    priceSlider.addEventListener('onMouseUp', (evt) => {
      min.value = evt.detail.value1.toString();
      max.value = evt.detail.value2.toString();
      if(this.mql.matches) min.form?.requestSubmit();
    });
    priceSlider.addEventListener('touchend', (evt) => {
      min.value = evt.detail.value1.toString();
      max.value = evt.detail.value2.toString();
      if(this.mql.matches) min.form?.requestSubmit();
    });
  }
  mobileFilters(){
    var html = document.documentElement;
    html.classList.add('activ-filter','show-overly');
    const blocks = this.querySelectorAll('.filters-item');
    const activeBlock = Array.from(blocks).find((blk) => blk.querySelector('input:checked')) || blocks[0];
    blocks.forEach((blk) => {
      blk.open = blk === activeBlock;
    });
  }
  accordionFilters(){
    if(this.classList.contains('filter-horizontal')) return;

    this.normalizeAccordion();

    this.addEventListener('click', (event) => {
      const summary = event.target.closest('.filters-title');
      if(!summary || !this.contains(summary)) return;

      const current = summary.closest('.filters-item');
      if(!current || current.open) return;

      this.querySelectorAll('.filters-item[open]').forEach((other) => {
        if(other !== current) other.removeAttribute('open');
      });
    });
  }
  normalizeAccordion(){
    if(this.classList.contains('filter-horizontal')) return;

    const blocks = Array.from(this.querySelectorAll('.filters-item'));
    const activeBlock = blocks.find((blk) => blk.querySelector('input:checked')) || blocks[0];

    blocks.forEach((blk) => {
      blk.open = blk === activeBlock;
    });
  }
  blockToggle(){
      const body = document.body,
        filters = document.querySelectorAll(".filter-horizontal .filters-title"),
        blocks = this.querySelectorAll('.filters-item');
      filters.forEach((blk) => {
        const act = blk.closest('.filters-item[open]');
        blocks.forEach((other) => {
           if(other !== act){
             other.removeAttribute('open');
           }
        });
      });
      body.addEventListener('click', function(e){
          blocks.forEach((blk) => {
            if(e.target.closest('.filters-item[open]')) return;
             blk.removeAttribute('open');
        });
      });
  }
}
customElements.define("filters-form", FiltersForm);

document.addEventListener('click', (event) => {
  const filterButton = event.target.closest('.btn-filter');
  if(filterButton){
    document.querySelector('filters-form')?.mobileFilters();
    return;
  }

  if(event.target.closest('.closeFilter')){
    document.documentElement.classList.remove('activ-filter', 'show-overly');
    return;
  }

  const facetLink = event.target.closest('.active-facets a, .js-facet-remove, .filter-panel-clear');
  if(facetLink){
    event.preventDefault();
    renderCollectionPage(facetLink.href);
    return;
  }

  const viewButton = event.target.closest('.change-view');
  if(viewButton){
    event.preventDefault();
    const href = new URL(window.location.href);
    href.searchParams.set('type', viewButton.dataset.view);
    renderCollectionPage(href.toString());
  }
});

window.addEventListener('popstate', () => renderCollectionPage(window.location.href, false));
